export enum NotificationSeverity {
  error = 'error',
  success = 'success',
  warning = 'warning',
}
